<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <loader></loader>
    <snackbars></snackbars>
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import Snackbars from "@/components/Snackbars.vue";

export default {
  components: {
    Loader,
    Snackbars
  },
  mounted() {
    let plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "https://www.line-website.com/social-plugins/js/thirdparty/loader.min.js"
    );
    plugin.async = true;
    plugin.defer = true;
    document.head.appendChild(plugin);
  }
};
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }

  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }

  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }

  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}</style>
